import type { IconProps } from './types';

export const JustifiedIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M20.5 17.7871L20.5771 17.7911C20.9551 17.8297 21.25 18.149 21.25 18.5371C21.2499 18.9252 20.9551 19.2446 20.5771 19.2832L20.5 19.2871H3.5C3.08586 19.2871 2.75012 18.9513 2.75 18.5371C2.75 18.1229 3.08579 17.7871 3.5 17.7871H20.5ZM20.5 11.2481L20.5771 11.252C20.955 11.2906 21.2498 11.6101 21.25 11.9981C21.25 12.3862 20.9551 12.7055 20.5771 12.7442L20.5 12.7481H3.5C3.08579 12.7481 2.75 12.4123 2.75 11.9981C2.7502 11.584 3.08591 11.2481 3.5 11.2481H20.5ZM20.5 4.71C20.9142 4.71 21.25 5.04579 21.25 5.46C21.25 5.87421 20.9142 6.21 20.5 6.21H3.5C3.08579 6.21 2.75 5.87421 2.75 5.46C2.75 5.04579 3.08579 4.71 3.5 4.71H20.5Z"
        fill={color}
      />
    </svg>
  );
};
